import { render, staticRenderFns } from "./artDetail.vue?vue&type=template&id=2cc0a1dc&scoped=true&"
import script from "./artDetail.vue?vue&type=script&lang=js&"
export * from "./artDetail.vue?vue&type=script&lang=js&"
import style0 from "./artDetail.vue?vue&type=style&index=0&id=2cc0a1dc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc0a1dc",
  null
  
)

export default component.exports